<script>
  import { format } from 'svelte-i18n';
  import { Collapse } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { classnames } from '@client/utils/classnames';

  /**
   * Additional CSS class name for the component
   * @type {string}
   * @default ''
   */
  let className = '';
  export { className as class };

  /**
   * Flag indicating whether the component is expanded or collapsed.
   * @type {boolean}
   * @default false
   */
  export let expanded = false;

  /**
   * Lucide icon name to display when the component is expanded.
   * @type {string}
   * @default 'chevron-up'
   */
  export let expandedIcon = 'chevron-up';

  /**
   * Text to display when the component is expanded.
   * @type {string}
   * @default 'Show less'
   */
  export let expandedText = 'label.SHOW_LESS';

  /**
   * Lucide icon name to display when the component is collapsed.
   * @type {string}
   * @default 'chevron-down'
   */
  export let collapsedIcon = 'chevron-down';

  /**
   * Text to display when the component is collapsed.
   * @type {string}
   * @default 'Show more'
   */
  export let collapsedText = 'label.SHOW_MORE';

  /**
   * Callback function triggered when the component is toggled.
   * @type {function}
   * @default () => {}
   */
  export let onToggle = () => {};

  /**
   * Type of the component, typically used for button styling.
   * @type {string}
   * @default 'button'
   */
  export let type = 'button';

  const onClick = () => {
    expanded = !expanded;
    onToggle(expanded);
  };

  $: classes = classnames('toggle', className);
</script>

<svelte:element this={type} class={classes} on:click={onClick}>
  {expanded ? $format(expandedText) : $format(collapsedText)}
  <Icon name={expanded ? expandedIcon : collapsedIcon} class="ms-1" />
</svelte:element>

<Collapse isOpen={expanded}>
  {#if expanded}
    <slot />
  {/if}
</Collapse>

<style lang="scss" src="./show-more.scss"></style>
